// extracted by mini-css-extract-plugin
export var layout = "AllOnFour-module--layout--57935";